import * as React from "react";
import { SVGProps } from "react";
const SvgShading = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.222 22.364a1 1 0 0 1 1.414 1.414l-2.828 2.828a.997.997 0 0 1-1.631-.324 1 1 0 0 1 .217-1.09l2.828-2.828ZM16 9c1.93 0 3.68.785 4.947 2.053h-.001a6.974 6.974 0 0 1 2.047 4.644L23 16c0 3.86-3.14 7-7 7a6.976 6.976 0 0 1-4.947-2.053A6.977 6.977 0 0 1 9 16c0-3.86 3.14-7 7-7Zm0 2c-2.757 0-5 2.243-5 5 0 1.379.561 2.629 1.466 3.534v-.001l7.067-7.068a4.985 4.985 0 0 0-3.276-1.458L16 11ZM6 15a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2h4Zm19.192-9.606a1 1 0 1 1 1.414 1.414l-2.828 2.828a.998.998 0 0 1-1.707-.707 1 1 0 0 1 .293-.707l2.828-2.828Zm-19.798 0a.999.999 0 0 1 1.414 0l2.828 2.828a1 1 0 1 1-1.414 1.414L5.394 6.808a.999.999 0 0 1 0-1.414ZM16 1a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0V2a1 1 0 0 1 1-1Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgShading;
